/**
 * Recipe input modes (T-365 step 6): transcription | project | extraction. An extraction recipe reads
 * products from a file; it renders no document, so no "generate" list may offer it.
 */

export const canGenerateDocument = (recipe: { input_mode?: string }): boolean => recipe.input_mode !== "extraction";

/** A recipe list response without the extraction recipes. */
export function withoutExtraction<T extends { recipes: { input_mode?: string }[] }>(response: T): T {
  return { ...response, recipes: response.recipes.filter(canGenerateDocument) };
}
